"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var addLeadingSlash = function (str) {
    if (typeof str == "string" && str[0] != "/") {
        str = "/" + str;
    }
    return str;
};
var removeLeadingSlash = function (str) {
    if (typeof str == "string" && str[0] == "/") {
        str = str.substring(1);
    }
    return str;
};
var removeTrailingSlash = function (str) {
    if (typeof str == "string" && str[str.length - 1] == "/") {
        str = str.substring(0, str.length - 1);
    }
    return str;
};
var addTrailingSlash = function (str) {
    if (typeof str == "string" && str[str.length - 1] != "/") {
        str = str + "/";
    }
    return str;
};
exports.default = { addLeadingSlash: addLeadingSlash, removeLeadingSlash: removeLeadingSlash, removeTrailingSlash: removeTrailingSlash, addTrailingSlash: addTrailingSlash };
